import type { ReactNode } from "react";

interface HudCardProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  className?: string;
  bodyClassName?: string;
}

export function HudCard({ title, subtitle, children, actions, footer, className, bodyClassName }: HudCardProps) {
  return (
    <div className={`hud-card ${className ?? ""}`}>
      {(title || subtitle || actions) && (
        <div className="hud-card__header">
          <div className="hud-card__titles">
            {title ? <div className="hud-title">{title}</div> : null}
            {subtitle ? <div className="hud-subtle">{subtitle}</div> : null}
          </div>
          {actions ? <div className="hud-card__actions">{actions}</div> : null}
        </div>
      )}
      <div className={`hud-card__body ${bodyClassName ?? ""}`}>{children}</div>
      {footer ? <div className="hud-card__footer">{footer}</div> : null}
    </div>
  );
}
